// extracted by mini-css-extract-plugin
export default {"container":"Adjust_container__9qYJp","alert":"Adjust_alert__gub3b","footerConfirmationTitle":"Adjust_footerConfirmationTitle__DT15J"};